import { MINCOL } from "../../../constants/const";
import DropdownFilter from "../SD_einsehen/DropdownFilter";

export const abschnittHeader = [
    {
        accessor: 'id',
        Header: 'ID'
    },

    {
        accessor: 'idBhfBeginn',
        Header: 'id_beginn'
    },

    {
        accessor: 'bhfbeginn',
        Header: 'von...',
        width: '21em'
    },

    {
        accessor: 'idBhfEnde',
        Header: 'id_ende'
    },

    {
        accessor: 'bhfende',
        Header: 'nach...',
        width: '21em'
    },

    {
        accessor: 'distanz',
        Header: 'Distanz',
        width: MINCOL
    },

    {
        accessor: 'gueltigVon',
        Header: 'Gültigkeitsbeginn',
        width: MINCOL
    },

    {
        accessor: 'gueltigBis',
        Header: 'Gültigkeitsende',
        width: MINCOL
    },

    {
        accessor: 'kreisId',
        Header: 'kreisId'
    },

    {
        accessor: 'kreis',
        Header: 'Kreis',
        width: MINCOL,
        Filter: DropdownFilter
    },

    {
        accessor: 'zvId',
        Header: 'zvId'
    },

    {
        accessor: 'zv',
        Header: 'Zweckverband',
        width: MINCOL,
        Filter: DropdownFilter
    },

    {
        accessor: 'eiuId',
        Header: 'eiuId'
    },

    {
        accessor: 'eiu',
        Header: 'Eiu',
        width: MINCOL,
        Filter: DropdownFilter
    },

    {
        accessor: 'strKatId',
        Header: 'strKatId'
    },

    {
        accessor: 'strKat',
        Header: 'Streckenkategorie',
        width: MINCOL,
        Filter: DropdownFilter
    }
]

export const hiddenColumns = ['id', 'idBhfBeginn', 'idBhfEnde', 'kreisId', 'zvId', 'eiuId', 'strKatId'];

export const listDropdowns = [
    {
        accessor: 'id_bhfbeginn',
        Header: 'von...'
    },
    {
        accessor: 'id_bhfende',
        Header: 'nach...'
    },
    {
        accessor: "kreisId",
        Header: "Kreis"
    },
    {
        accessor: "zvId",
        Header: "Zweckverband"
    },
    {
        accessor: "eiuId",
        Header: "Eisenbahninfraunternehmen"
    },
    {
        accessor: "strKatId",
        Header: "Streckenkategorie"
    }
];

export const listInput = [
    // {
    //     accessor: 'absNr',
    //     Header: 'Nummer',
    //     type: "text"
    // },
    {
        accessor: 'distanz',
        Header: "Länge (in m)",
        type: "number"
    },
    {
        accessor: "kommentar",
        Header: "Kommentar",
        type: "text"
    }
];


export const csvHeaderAbs = [
    'von',
    'nach',
    'Distanz',
    'Gültigkeitsbeginn',
    'Gültigkeitsende',
    'Kreis',
    'Zweckverband',
    'Eiu',
    'Streckenkategorie',
    'Kommentar'
]